<template>
	<nk-page commercialAccess="System" :policyClaims="['General_Access_Management']">
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="edition" :modelValue="retreiveIsEmpty() ? 'edit' : 'new'"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="container-fluid h-100 overflow-auto">
			<div class="row flex-row-reverse">
				<div class="col-12 nk-card form-container">
					<nk-stabs :activeTab="'basic-info'">
						<nk-stab :id="'basic-info'" :name="$t('operationRole.claims')">
							<AccessControlTree ref="accessControlTree" :data="data" @operationRolesChanged="val => onOperationRolesChange(val)" />
						</nk-stab>
						<nk-stab :id="'data-access'" :name="$t('operationRole.dataAccess')" v-if="data.accessData">
							<div class="row">
								<div class="col-12">
									<div class="">
										<div class="alert alert-info text-center p-2" style="font-size:1rem;">
											<div class="">{{ $t('policy.infoBox-title') }}:</div>
											<span style="font-size:1.5rem">{{ data.accessData.objectDescription }}</span>
										</div>
									</div>
									<div class="mt-3 text-center">
										<div class="text-red mb-2">
											{{ $t('policy.select-restrict-item-by-click') }}
										</div>
										<div class="d-flex justify-content-center mb-3">
											<div class="col-12 col-md-6 col-lg-4 p-0">
												<nk-input v-model="searchKeyword" :options="searchInputOptions" :tabindex="100" />
											</div>
										</div>
										<div style="margin:auto" class="privilege-table">
											<div class="trow thead">
												<div></div>
												<div v-for="(type, index) in privilegeTypes" :key="index">
													<div class="d-flex flex-column gap-5">
														<span>{{ $t('PrivilegeTypes.' + type.key) }}</span>
														<div class="d-flex justify-content-between">
															<div class="no-restrict static-size p-1" @click="toggleAllRoles(type.key, false)">
																<icon :icon="'check'"></icon>
															</div>
															<div class="restrict static-size p-1" @click="toggleAllRoles(type.key, true)">
																<icon :icon="'times'"></icon>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="trow tbody" v-for="role in filteredOperationRoles" :key="role.id">
												<div class="title">
													<div class="text-muted">
														<icon v-if="!role.dedicatedUser" name="users-crown" />
														{{ role.dedicatedUser ? $t('policy.user') : $t('policy.role') }}:
													</div>
													{{ role.dedicatedUser ? role.dedicatedUser.firstName + ' ' + role.dedicatedUser.lastName : role.name }}
												</div>
												<div v-for="(type, index) in privilegeTypes" :key="index" class="cell">
													<div class="no-restrict" :class="{ 'selected': privileges.findIndex(x => x.operationRoleId == role.id && x.privilegeTypes.indexOf(type.key.toLowerCase()) > -1 && !x.restrict) > -1 }" @click="toggleSelection(type.key, role.id, false)">
														<icon :icon="'check'"></icon>
													</div>
													<div class="restrict" :class="{ 'selected': privileges.findIndex(x => x.operationRoleId == role.id && x.privilegeTypes.indexOf(type.key.toLowerCase()) > -1 && x.restrict) > -1 }" @click="toggleSelection(type.key, role.id, true)">
														<icon :icon="'times'"></icon>
													</div>
												</div>
											</div>
										</div>
										<div v-if="filteredOperationRoles.length === 0" class="text-muted text-center p-3">
											{{ $t('no-items-found') }}
										</div>
									</div>
								</div>
							</div>
						</nk-stab>
					</nk-stabs>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { post, get } from '~/plugins/nikan-api'
	import $sc from '~/plugins/shortcut.collection.js'
	import validators, { isEmpty, Checker } from '~/statics/validators'
	import Endpoints from '@nikan/endpoints'
	import emptyId from '~/statics/empty-id'
	import AccessControlTree from './access-control-tree.vue'

	import { mapGetters } from "vuex"

	export default {
		modal: {
			size: 'fullscreen',
			stateUID: 'access-control',
			helpTag: 'AcessControl'
		},
		props: {
			data: { type: Object, required: true },
		},
		components: {
			AccessControlTree
		},
		data() {
			return {
				settings: {},
				selectAll: false,
				privileges: [],
				allOperationRoles: [],
				searchKeyword: '',
				searchInputOptions: {
					placeholder: this.$t('search'),
					icon: 'search',
				},
				validators: {
					name: validators('required'),
				},
				privilegeTypes: [],
				saveAccessButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: true,
					icon: 'save',
					handle: (button, page, e) => {
						e.preventDefault()
						this.save()
					},
					policyClaims: 'General_Access_Management',
				},
			}
		},
		computed: {
			...mapGetters({
				allProperties: 'properties/all',
			}),
			operationRolesByDedicates() {
				return _.orderBy(this.allOperationRoles.filter(x => !x.dedicatedUser || x.dedicatedUser.isActive), ['dedicatedUser', 'name'], ['desc', 'asc'])
			},
			filteredOperationRoles() {
				if (!this.searchKeyword || !this.searchKeyword.trim()) {
					return this.operationRolesByDedicates
				}
				const keyword = this.searchKeyword.trim().toLowerCase()
				const words = typeof keyword.getWords === 'function' ? keyword.getWords() : keyword.split(/\s+/).filter(Boolean)

				return this.operationRolesByDedicates.filter(role => {
					const searchTargets = [
						role.name || '',
						role.title || '',
					]

					if (role.dedicatedUser) {
						const u = role.dedicatedUser
						searchTargets.push(
							u.firstName || '',
							u.lastName || '',
							`${u.firstName || ''} ${u.lastName || ''}`.trim(),
							u.userName || '',
						)
					}

					const combinedText = searchTargets.join(' ').toLowerCase()

					return words.every(word => combinedText.includes(word))
				})
			},
		},
		created() {

		},
		mounted() {
			this.prepareWindow(this.$t('operationRole.claims'), [this.saveAccessButton])

			if (this.data.accessData) {
				this.getUserDataAccessList().then((res) => {
					this.privileges = res.map((x) => {
						return {
							id: x.id,
							operationRoleId: x.operationRole.id,
							privilegeTypes: x.privilegeType.split(',').map(x => x.toLowerCase()),
							restrict: x.restrict,
							rowState: 'unchanged',
						}
					})
				})
				this.getProperties()
			}
		},
		methods: {
			save() {
				var wait = this.$wait(this.$el)
				var url = Endpoints.getUrl('accessControl.modify')
				var accessControls = []
				if (this.privileges.length > 0) {
					accessControls = this.privileges.filter(x => { return !(x.privilegeTypes.length === 0 && x.rowState == 'new') }).map((x) => {
						return {
							id: x.id,
							operationRole: { id: x.operationRoleId },
							entityId: this.data.accessData.entityId,
							entityType: this.data.accessData.entityType,
							privilegeType: x.privilegeTypes.join(','),
							restrict: x.restrict,
							rowState: x.rowState,
						}
					})
				}
				this.operationRoles = this.$refs.accessControlTree.commitData()
				post(url, {
					operationRoles: this.operationRoles,
					accessControls: accessControls,
				})
					.then((result) => {
						this.resolve(this.operationRoles)
						wait.end()
						this.$toast(this.$t('msg.create-success'), { type: 'success' })
					})
					.catch(() => {
						wait.end()
					})
			},
			retreiveIsEmpty() {
				if (isEmpty(this.data)) {
					return false
				} else {
					return true
				}
			},
			getProperties() {
				this.cache_getOrSet(`properties_key`, 0, () => {
					return this.allProperties
				})
					.then((items) => {
						let activeTypes = []
						if (this.data.activeTypes) {
							activeTypes = this.data.activeTypes
						} else {
							activeTypes = ['Delete', 'Edit']
							let ignoreEntityTypes = ['FiscalPeriod', 'Company', 'FactorBunch', 'Print', 'SalaryPeriod', 'Workshop', 'DocumentHeader', 'DynamicReport']
							if (this.data.accessData && ignoreEntityTypes.includes(this.data.accessData.entityType))
								activeTypes.push(...['View', 'All'])
							let extraEntityTypes = ['FloatingCenter', 'Account']
							if (this.data.accessData && extraEntityTypes.includes(this.data.accessData.entityType)) {
								activeTypes.push(...['View', 'Balance', 'TurnOver'])
							}
						}
						this.privilegeTypes = items.filter(
							(x) => x.group === 'PrivilegeTypes' && activeTypes.indexOf(x.key) > -1
						)
					})
					.catch((cerror) => {
						alert('could not fetch Properties')
					})
			},
			downloadProperties() {
				return new Promise((resolve, reject) => {
					post(Endpoints.getUrl('general.getAllProperties'))
						.then((result) => {
							resolve(result.data.items)
						})
						.catch((error) => {
							reject(error.message)
						})
				})
			},
			toggleSelection(type, operationRoleId, restrict, ignoreSelected = false) {
				type = type.toLowerCase()
				// for example when edit has restrict, it should remove non-restrict from privileges
				const removeOpposite = () => {
					let index2 = this.privileges.findIndex(
						(x) => x.operationRoleId == operationRoleId && x.restrict == !restrict
					)
					if (index2 > -1) {
						let i = this.privileges[index2].privilegeTypes.indexOf(type)
						if (i > -1) {
							this.privileges[index2].privilegeTypes.splice(i, 1)
							this.privileges[index2].rowState = isEmpty(
								this.privileges[index2].id
							)
								? 'new'
								: 'changed'
						}
					}
				}

				let index = this.privileges.findIndex(
					(x) => x.operationRoleId == operationRoleId && x.restrict == restrict
				)
				if (index === -1) {
					this.privileges.push({
						id: emptyId,
						operationRoleId: operationRoleId,
						privilegeTypes: [type],
						restrict: restrict,
						changed: true,
						rowState: 'new',
					})
					removeOpposite()
				} else {
					let i = this.privileges[index].privilegeTypes.indexOf(type)
					if (i === -1) {
						this.privileges[index].privilegeTypes.push(type)
						removeOpposite()
					} else if (!ignoreSelected) {
						this.privileges[index].privilegeTypes.splice(i, 1)
					}
					this.privileges[index].rowState = isEmpty(this.privileges[index].id)
						? 'new'
						: 'changed'
				}

			},
			allRolesSelected(type, restrict) {
				const targetRoles = this.filteredOperationRoles && this.filteredOperationRoles.length > 0 ? this.filteredOperationRoles : this.operationRolesByDedicates
				return targetRoles.length > 0 && targetRoles.every(role => {
					const priv = this.privileges.find(item => item.operationRoleId == role.id && item.restrict === restrict)
					return priv && priv.privilegeTypes.includes(type.toLowerCase())
				})
			},
			getUserDataAccessList() {
				return new Promise((resolve, reject) => {
					var data = {
						entityType: this.data.accessData.entityType,
						entityId: this.data.accessData.entityId,
					}
					post(Endpoints.getUrl('accessControl.get-list'), data)
						.then((result) => {
							resolve(result.data.items)
						})
						.catch((error) => {
							reject(error.message)
						})
				})
			},
			toggleAllRoles(type, restrict) {
				const targetRoles = this.filteredOperationRoles && this.filteredOperationRoles.length > 0 ? this.filteredOperationRoles : this.operationRolesByDedicates
				const ignoreSelected = !this.allRolesSelected(type, restrict)

				targetRoles.forEach((role) => {
					this.toggleSelection(type, role.id, restrict, ignoreSelected)
				})
			},
			onOperationRolesChange(val) {
				this.allOperationRoles = val
			}
		},
	}
</script>
<style scoped>
	.operation-claims-label .custom-switch {
		display: inline;
		float: left;
		margin-right: 5px;
	}
</style>
